import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { formatDate } from '@angular/common';
import { monthsLabels } from 'src/app/app.models';

@Component({
    selector: 'app-dob',
    templateUrl: './dob.component.html',
    styleUrls: ['./dob.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DOBComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class DOBComponent implements ControlValueAccessor {
  @Input() placeholder: string;
  @Input() type: string;
  _value: string;

  onChange = (value: any) => {};
  onTouch = () => {};

  writeValue(value: any): void {
    if (value) {
      this._value = value;
    } else {
      this._value = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {}

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this._value = input.value
     this.onChange(this._value)
  }

  touch(){
    this.onTouch()
  }
}
